import { render, staticRenderFns } from "./AddLessonCardForTeacher.vue?vue&type=template&id=45fb48d2&scoped=true&"
import script from "./AddLessonCardForTeacher.vue?vue&type=script&lang=js&"
export * from "./AddLessonCardForTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AddLessonCardForTeacher.vue?vue&type=style&index=0&id=45fb48d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb48d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VSelect})
